module.exports = __webpack_public_path__ + "img/04n.3c8f082a.png";